import React from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import type { TenantThemeConfig } from '../../types/theme'
import './affiliateLayout.css'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

export interface AffiliateOutletContext {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

interface ModernAffiliateLayoutProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

const TABS = [
  { to: 'overview', label: 'ภาพรวม', icon: 'fas fa-sitemap' },
  { to: 'member', label: 'สมาชิก', icon: 'fas fa-users' },
  { to: 'income', label: 'รายได้', icon: 'fas fa-chart-bar' },
  { to: 'topten', label: 'Top 10', icon: 'fas fa-trophy' },
]

/** Layout หน้าแนะนำเพื่อน (affiliate): หัวข้อ + แท็บ 4 อัน (ภาพรวม, สมาชิก, รายได้, Top 10) + Outlet */
const ModernAffiliateLayout: React.FC<ModernAffiliateLayoutProps> = ({ themeConfig, assetConfig }) => {
  const context: AffiliateOutletContext = { themeConfig, assetConfig }

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div className="affiliate-header c_quinary text-center position-relative">
              <Link to="/dashboard" className="link_back">
                กลับหน้าหลัก
              </Link>
              <h3 className="c_tertiary font_md">ระบบแนะนำ</h3>
            </div>

            <div
              className="affiliate-tabs nav nav-pills mt-3 mb-3"
              id="pills-tab"
              role="tablist"
            >
              {TABS.map((tab) => (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  end={tab.to === 'overview'}
                  className={({ isActive }) =>
                    `nav-link${isActive ? ' active' : ''}`
                  }
                >
                  <span className="affiliate-tabs__icon" aria-hidden>
                    <i className={tab.icon} />
                  </span>
                  <span className="affiliate-tabs__label">{tab.label}</span>
                </NavLink>
              ))}
            </div>
            <Outlet context={context} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernAffiliateLayout
